import React from "react";
import "../App.css"; 

const Loading = () => {
  return <div className="simple-loader"></div>;
};

export default Loading;